import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = ({ children, noPad = false }) => (
  // overflowX: "clip" contains decorative/3D-transformed bleed (the map plane,
  // shard imagery) so no page ever scrolls sideways. Unlike overflow:hidden it
  // does NOT create a scroll container, so position:sticky / fixed still work.
  <div className="min-h-screen flex flex-col relative" style={{ overflowX: "clip" }}>
    <Navbar />
    <main className={`flex-1 ${noPad ? "" : "pt-[88px]"} relative z-10`}>{children}</main>
    <Footer />
  </div>
);

export default Layout;
